import React, { useState } from "react";
import { motion } from "framer-motion";
import Github from "../icons/Github.icons";
import MagneticWrapper from "../button/Magnetic";

const FeaturedProject = ({
    title,
    description,
    projectLink,
    githubLink,
    imageAlt,
}) => {
    const [showMore, setShowMore] = useState(false);
    const FramerImage = motion.img;

    const toggleShowMore = () => {
        setShowMore((prevState) => !prevState);
    };

    return (
        <article className="w-full flex flex-col md:flex-row items-center justify-between relative rounded-2xl border border-solid border-dark dark:border-light bg-light dark:bg-dark shadow-xl p-4 sm:p-6 md:p-8 mb-6 transition-all duration-300 ease-in-out">
            {/* Decorative background */}
            <div className="absolute top-0 -right-2 -z-10 w-[101%] h-[103%] rounded-[2rem] bg-dark dark:bg-light rounded-br-2xl" />

            {/* Project image */}
            <a
                href={projectLink}
                target="_blank"
                rel="noreferrer"
                className="w-full md:w-1/2 mb-4 md:mb-0 cursor-pointer overflow-hidden rounded-lg"
            >
                <FramerImage
                    src={imageAlt}
                    alt={title}
                    className="h-40 sm:h-48 md:h-64 lg:h-72 xl:h-80 w-full object-cover"
                    whileHover={{ scale: 1.05 }}
                    transition={{ duration: 0.2 }}
                />
            </a>

            {/* Project details */}
            <div className="flex flex-col w-full md:w-2/3 items-start justify-between md:pl-6">
                <span className="text-sm sm:text-base font-medium text-[#ff934f] dark:text-primaryDark mb-2">
                    Featured Project
                </span>

                <a
                    href={projectLink}
                    target="_blank"
                    rel="noreferrer"
                    className="underline-offset-2 hover:underline"
                >
                    <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-dark dark:text-light mb-2">
                        {title}
                    </h2>
                </a>

                <p className="text-sm sm:text-base text-dark dark:text-light mb-4">
                    {showMore ? description : `${description.slice(0, 100)}...`}
                </p>

                {/* Show More/Show Less button */}
                <button
                    onClick={toggleShowMore}
                    className="text-xs sm:text-sm font-semibold text-[#ff4d5a] hover:text-[#ff934f] transition-colors"
                >
                    {showMore ? "Show Less" : "Show More"}
                </button>

                <div className="flex items-center space-x-4 mt-4">
                    <a
                        href={githubLink}
                        target="_blank"
                        rel="noreferrer"
                        className="w-6 sm:w-8"
                    >
                        <MagneticWrapper>
                            <Github />
                        </MagneticWrapper>
                    </a>
                    <MagneticWrapper>
                        <a
                            href={projectLink}
                            target="_blank"
                            rel="noreferrer"
                            className="ml-4 rounded-lg p-2 px-4 text-xs sm:text-sm font-semibold text-light bg-gradient-to-r from-[#ff4d5a] to-[#ff934f] dark:from-[#ff7d85] dark:to-[#ffae83] dark:text-dark hover:scale-105 transition-transform"
                        >
                            Visit Project
                        </a>
                    </MagneticWrapper>
                </div>
            </div>
        </article>
    );
};

export default FeaturedProject;
